var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgApexAnalytics = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#891E21",
    d: "M35.121 34.589 26.39 20.862l-.044.064-2.936 4.67-.037.05c-.18.275-.517.799-.667 1.06l-.062.103-1.178 1.878 3.278 5.505q.393.654.973 1.163c.473.415 1.09.626 1.82.626H36l-.891-1.399zm-8.795-16.824L35.67 4h-8.21c-.548 0-1.028.147-1.427.428-.349.243-.66.6-.96 1.08l-3.153 5.045 4.145 6.796.255.422z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#009EC9",
    d: "m21.028 24.075.025-.038 2.936-4.67-.3-.485-8.245-13.515c-.256-.447-.586-.799-.966-1.022-.393-.23-.91-.339-1.59-.339H4.386l.935 1.418 9.337 14.116L4 36h7.99a2.57 2.57 0 0 0 1.366-.37 2.7 2.7 0 0 0 .374-.288 5.7 5.7 0 0 0 .928-1.105l5.635-8.968c.062-.108.143-.236.224-.37s.169-.275.25-.396c.037-.064.08-.121.112-.172.068-.11.124-.192.156-.237z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgApexAnalytics);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/apex-analytics.f9c447c0.svg";